"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
var _constants = require("./lib/constants");
class BotTemplatesApi extends _basic_data_hub_api.default {
  async copy(botId) {
    return this._callApi({
      path: `/bots`,
      payload: {
        botId
      },
      method: 'put',
      queryParams: {}
    });
  }
  async getBotTemplates(_ref) {
    let {
      query = {
        isDeleted: false
      },
      projection
    } = _ref;
    return this._callApi({
      path: `/bots`,
      queryParams: {
        query,
        projection,
        sandbox: true
      }
    });
  }
  async getBotTemplatesByToken(_ref2) {
    let {
      query = {},
      projection,
      limit,
      token
    } = _ref2;
    const binding = await this.getBinding();
    return binding.query.listTemplates({
      entity: _constants.BOT,
      params: {
        queryParams: query,
        limit,
        last: token
      },
      sourceId: query.sourceId,
      forceSandbox: false
    }, projection || ['records', 'last']);
  }
}
var _default = BotTemplatesApi;
exports.default = _default;